export enum ObjType {
	CUBE_CAMERA = 'cubeCamera',
	AUDIO_LISTENER = 'audioListener',
	POSITIONAL_AUDIO = 'positionalAudio',
}
